module.exports = __webpack_public_path__ + "static/media/COS_CAUDALIE.054d12cf.png";